export const generateGroupCode = () => {
  const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";

  let letterPart = "";
  let numberPart = "";

  for (let i = 0; i < 4; i++) {
    const randomLetterIdx = Math.floor(Math.random() * letters.length);
    letterPart += letters[randomLetterIdx];
  }

  for (let i = 0; i < 4; i++) {
    const randomNumberIdx = Math.floor(Math.random() * numbers.length);
    numberPart += numbers[randomNumberIdx];
  }

  return `${letterPart}-${numberPart}`;
};
